const portalServiceTypeList = [
    { value: 1, text_en: 'IDSDP', text_bn: 'আইডিএসডিপি' },
    { value: 2, text_en: 'API', text_bn: 'এপিআই' },
    { value: 3, text_en: 'Link', text_bn: 'লিঙ্ক' }
]

export default {
  portalServiceTypeList
}
